export default __webpack_public_path__ + "static/media/Icon material-event.b89d76de.svg";